import Vue from 'vue'
import Vuex from 'vuex'
import application from './modules/application'
import account from './modules/account'
import database from './modules/database'
import sidebar from './modules/sidebar'
import property from './modules/property'
import epma from './modules/epma'
import company from './modules/company'
import reports from './modules/reports'
import quotes from './modules/quotes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    application,
    account,
    database,
    sidebar,
    property,
    epma,
    company,
    reports,
    quotes
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js